import { ErrorBoundary as BaseErrorBoundary } from 'react-error-boundary';

import { IntentionSetModal } from '@grow-therapy-team/seedling-components';

import { useGetCurrentIntentionQuery } from './useGetCurrentIntentionQuery';

function ErrorBoundary({ children }: { children: React.ReactNode }) {
  return <BaseErrorBoundary FallbackComponent={() => null}>{children}</BaseErrorBoundary>;
}

export const IntentionSetModalWrapper = ({
  isOpen,
  onClose,
  clientName,
  initials,
  clientUserShortId,
  providerShortId,
  appointmentShortId,
}: {
  isOpen: boolean;
  onClose: () => void;
  clientName: string;
  initials: string;
  clientUserShortId: string;
  providerShortId: string;
  appointmentShortId: string;
}) => {
  const { currentIntention, loading } = useGetCurrentIntentionQuery(
    clientUserShortId,
    providerShortId,
    appointmentShortId,
  );

  if (loading || !currentIntention) {
    return <></>;
  }

  return (
    <ErrorBoundary>
      <IntentionSetModal
        isOpen={isOpen}
        onClose={onClose}
        name={clientName}
        initials={initials}
        intention={currentIntention.contentText}
      />
    </ErrorBoundary>
  );
};
